import { useContext } from 'react'
import { DashboardStateContext } from '@features/dashboard/store/dashboard-state'

export function useDashboardState() {
  const value = useContext(DashboardStateContext)

  if (!value) {
    throw new Error(
      'useDashboardState must be used inside DashboardStateProvider.',
    )
  }

  return value
}
